import React from 'react';

const SelectComp = ({ val, setVal, options, selectName }) => {
  return (
    <select
      className="form-select"
      name = {selectName}
      id="choices-message-type"
      value={val}
      onChange={(e) => setVal(e.target.value)}
    >
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  );
};

export default SelectComp;